<template>
  <footer class="footer">
    <div class="footer-inner">
      <ul class="footer-nav">
        <li>
          <strong>
            <router-link :to="{name: 'Company', params : { 'locale' : locale === 'en' ? 'en' : undefined }}">{{ $t('menuCompany.company') }}</router-link>
          </strong>
          <ul>
            <li>
              <router-link :to="{name: 'Company', params : { child: 'culture', 'locale' : locale === 'en' ? 'en' : undefined }}" @click.native="goPageAnchor">{{ $t('menuCompany.woowaCulture') }}</router-link>
            </li>
            <li>
              <router-link :to="{name: 'Company', params : { child: 'history', 'locale' : locale === 'en' ? 'en' : undefined }}" @click.native="goPageAnchor">{{ $t('menuCompany.history') }}</router-link>
            </li>
            <li>
              <router-link :to="{name: 'Company', params : { child: 'ethical', 'locale' : locale === 'en' ? 'en' : undefined }}" @click.native="goPageAnchor">{{ $t('menuCompany.ethicalManagement') }}</router-link>
            </li>
          </ul>
        </li>
        <li>
          <strong>
            <router-link :to="{name: 'Service', params : { child: 'order', 'locale' : locale === 'en' ? 'en' : undefined }}">{{ $t('menuService.service') }}</router-link>
          </strong>
          <ul>
            <li>
              <router-link :to="{name: 'Service', params : { child: 'order', 'locale' : locale === 'en' ? 'en' : undefined }}" @click.native="goPageAnchor">{{ $t('menuService.deliveryTakeout') }}</router-link>
            </li>
            <li>
              <router-link :to="{name: 'Service', params : { child: 'commerce', 'locale' : locale === 'en' ? 'en' : undefined }}" @click.native="goPageAnchor">{{ $t('menuService.commerce') }}</router-link>
            </li>
            <li>
              <router-link :to="{name: 'Service', params : { child: 'ceo', 'locale' : locale === 'en' ? 'en' : undefined }}" @click.native="goPageAnchor">{{ $t('menuService.vendorsRiders') }}</router-link>
            </li>
            <li>
              <router-link :to="{name: 'Service', params : { child: 'culture', 'locale' : locale === 'en' ? 'en' : undefined }}" @click.native="goPageAnchor">{{ $t('menuService.culture') }}</router-link>
            </li>
          </ul>
        </li>
        <li>
          <strong>
            <router-link :to="{name: 'Writing', params : { 'locale' : locale === 'en' ? 'en' : undefined }}" @click.native="goTop">{{ $t('menuTogetherValue') }}</router-link>
          </strong>
          <ul v-if="!!writingCategories">
            <template v-for="(item, key) in writingCategories">
              <li v-if="item.categorySeq !== 0" :key="key">
                <router-link
                  :to="{name: 'Writing', params : { 'locale' : locale === 'en' ? 'en' : undefined , category : item.categorySeq}, query : {page : 1, offset: true}}"
                  @click.native="goPageAnchor"
                >
                  {{ locale === 'en' ? item.categoryEnglishName : item.categoryKoreaName }}
                </router-link>
              </li>
            </template>
          </ul>
        </li>
        <li>
          <strong>
            <router-link :to="{name: 'NewsroomReport', params : { 'locale' : locale === 'en' ? 'en' : undefined }, query : {page : 1}}" @click.native="goTop">{{ $t('menuNewsroom.newsroom') }}</router-link>
          </strong>
          <ul>
            <li>
              <router-link
                :to="{name: 'NewsroomReport', params : { 'locale' : locale === 'en' ? 'en' : undefined }, query : {page : 1, offset: true}}"
                @click.native="goPageAnchor"
              >
                {{ $t('menuNewsroom.press') }}
              </router-link>
            </li>
            <li>
              <router-link
                :to="{name: 'NewsroomMedia', params : { 'locale' : locale === 'en' ? 'en' : undefined }, query : {page : 1, offset: true}}"
                @click.native="goPageAnchor"
              >
                {{ $t('menuNewsroom.release') }}
              </router-link>
            </li>
            <li>
              <router-link
                :to="{name: 'NewsroomFact', params : { 'locale' : locale === 'en' ? 'en' : undefined }, query : {page : 1, offset: true}}"
                @click.native="goPageAnchor"
              >
                {{ $t('menuNewsroom.factCheck') }}
              </router-link>
            </li>
          </ul>
        </li>
        <li>
          <strong>
            <router-link :to="{name: 'Fonts', params : { 'locale' : locale === 'en' ? 'en' : undefined }}">{{ $t('menuFonts') }}</router-link>
          </strong>
        </li>
        <li class="other">
          <ul>
            <li>
              <router-link :to="{name: 'Place', params : { 'locale' : locale === 'en' ? 'en' : undefined }}">{{ $t('menuLocation') }}</router-link>
            </li>
            <li>
              <router-link :to="{name: 'Notice', params : { 'locale' : locale === 'en' ? 'en' : undefined}, query : { page : 1}}">{{ $t('menuNotices') }}</router-link>
            </li>
            <li class="nav-policy">
              <router-link :to="{name: 'Policy', params : { 'locale' : locale === 'en' ? 'en' : undefined }}">{{ $t('menuPolicy') }}</router-link>
            </li>
            <li class="nav-partnership">
              <router-link :to="{name: 'questionPartnership', params : { 'locale' : locale === 'en' ? 'en' : undefined }}">{{ $t('menuPartnerships') }}</router-link>
            </li>
            <li class="ccm">
              <a href="https://www.kca.go.kr/ccm/" target="_blank">
                <icon-ccm />
                <span>{{ $t('consumerFocus') }}</span>
              </a>
            </li>
          </ul>
        </li>
      </ul>
      <div class="footer-family link-select">
        <button
          class="link-select-button"
          type="button"
          :class="{
            'link-select-active': isFamilyShow
          }"
          @click="onFamilyToggle"
        >
          <span>{{ $t('affiliatedWebsites') }}</span>
          <span class="down"><icon-chevron-down /></span>
        </button>
        <transition name="link-select">
          <ul v-if="isFamilyShow" class="link-select-list">
            <li v-for="(item, key) in familySite" :key="key" :data-level="item.connectionSiteTypeLevel">
              <a :href="item.connectionSiteUrl" target="_blank">{{ locale === 'ko' ? item.connectionSiteKoreaName : item.connectionSiteEnglishName }}</a>
            </li>
          </ul>
        </transition>
      </div>
      <div class="footer-address">
        <h2>{{ $t('woowaCorp') }}</h2>
        <address>
          <p>
            <span>{{ $t('bzNumber') }} : 120-87-65763</span>
            <i>|</i>
            <span>{{ $t('ceo') }} : {{ $t('kimbongjin') }}, {{ $t('kimbeomjun') }}</span>
            <i>|</i>
            <span>{{ $t('address') }} : {{ $t('addressDetail') }}</span>
          </p>
        </address>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapGetters } from 'vuex'
import menu from '@/mixins/menu'

export default {
  components: {
    iconChevronDown: () => import('@/static/svg/chevron-down.svg'),
    iconCcm: () => import('@/static/svg/ccm.svg')
  },
  mixins: [
    menu
  ],
  data () {
    return {
      isFamilyShow: false
    }
  },
  computed: {
    ...mapGetters({
      locale: 'locale/GET_LOCALE',
      siteConnectionLevelSecond: 'site/siteConnectionLevelSecond',
      siteConnectionLevelThird: 'site/siteConnectionLevelThird',
      writingCategories: 'categories/get_writing_categories'
    }),
    familySite () {
      return [
          ...this.siteConnectionLevelSecond,
          ...this.siteConnectionLevelThird
      ]
    }
  },
  methods: {
    // onGoSticky () {
    //   if (this.$route.params && this.$route.params.child) {
    //     const isPcHeader = window.matchMedia('(min-width: 980px)')
    //     const offset = isPcHeader.matches ? 71 : 50
    //
    //     const targetOffsetTop = document.getElementById(this.$route.params.child).offsetTop - offset
    //
    //     window.scrollTo('scrollBehavior' in document.documentElement.style ? {
    //       // behavior: 'smooth',
    //       top: targetOffsetTop
    //     } : {
    //       top: targetOffsetTop
    //     })
    //   }
    // },
    onFamilyToggle () {
      this.isFamilyShow = !this.isFamilyShow

      const docEvents = (e) => {
        if (!e.target.closest('.footer-family')) {
          this.isFamilyShow = false
          document.documentElement.removeEventListener('click', docEvents)
        }
      }

      document.documentElement.addEventListener('click', docEvents)
    }
  }
}
</script>
